import React from "react";
import { v4 as uuidv4 } from 'uuid';

// formated data for graphic
export const dataFormated = (pData: any[]) => {
  if (pData.length !== 0) {
    return pData.map((d) => {
      return {
        time: new Date(
          new Date(d.time).getUTCFullYear(),
          new Date(d.time).getUTCMonth(),
          new Date(d.time).getUTCDate()
        ),
        value: d.v === undefined ? d.value !== null ? d.value : 0 : d.v !== null ? d.v : 0,
      };
    });
  } else {
    return [];
  }
};

// formated tresholds data for graphic
export const tresholdsDataFormated = (pTresholds: any[]) => {
  let tresholdsList: any[] = [];
  pTresholds.forEach((treshold) => {
    tresholdsList.push(dataFormated(treshold));
  });
  return tresholdsList;
};

export const renderLabelsOnGraphics = (pValue: any) => {
  return (
    Number(pValue.value).toLocaleString() +
    ' - ' +
    new Date(pValue.time).toLocaleDateString('fr')
  );
};

// black overlay
export const BlackOverlay = [
  {
    target: 'data',
    eventHandlers: {
      onMouseOver: () => {
        return [
          {
            target: 'data',
            mutation: (props) => {
              return {
                style: Object.assign({}, props.style, {
                  fill: 'black',
                }),
              };
            },
          },
          {
            target: 'labels',
            mutation: () => ({ active: true }),
          },
        ];
      },
      onMouseOut: () => {
        return [
          {
            target: 'data',
            mutation: () => {
              return null;
            },
          },
          {
            target: 'labels',
            mutation: () => ({ active: false }),
          },
        ];
      },
    },
  },
];

// to avoid Victory error domain, if there is one measure for first data pompe
export const testIfDatesAreEqual = (pDateOne: any, pDateTwo: any) => {
  if (pDateOne === pDateTwo) {
    return true;
  } else {
    return false;
  }
};

export const addOneDay = (pDate: any) => {
  const dateToUpdate = new Date(pDate);
  dateToUpdate.setDate(dateToUpdate.getDate() + 1);
  return dateToUpdate;
};

export const defineXPositionOfLegend = (pTitle: string) => {
  if(pTitle === 'Niveaux d\'eau du PR'){
    return 100;
  } else if (pTitle === 'Volume relevé du PR'){
    return 210;
  } else {
    return 230;
  }
};

export const tresholdsTable = (pTitle: string, pLegendColors: any[], pStateColors: string[], pTresholds: any) => {
  const colorization = pTitle !== 'Niveaux d\'eau du PR' && pTitle !== 'Volume relevé du PR' ? pStateColors : pLegendColors?.filter((l) => l.name.includes('Seuil') && l.symbol.fill).map((l) => l.symbol.fill);
  const nameOfTresholds = pTitle !== 'Niveaux d\'eau du PR' ? 'Min/Max' : 'Alerte/Vigilance';
  const tresholdsData = pTresholds.filter((t) => t.length > 0);
  return (
    <div
      style={{ alignItems: 'center', display: 'inline-flex', margin: '2px', fontSize: '14px' }}
    >
      <div>Seuils ({nameOfTresholds}) : </div>
      {
      (tresholdsData.length > 0 && tresholdsData[0].length > 0 ? tresholdsData.map((p, key) => {
        return (
          <div
            key={uuidv4()}
            style={{
              marginRight: '5px',
              marginLeft: '5px',
              borderRadius: '5px',
              padding: '5px',
              display: colorization[key] === 'transparent'
                ? 'none'
                : 'block'
            }}
          >
            <span
              style={{
                color:
                  colorization[
                    pTitle !== 'Niveaux d\'eau du PR' &&
                    pTitle !== 'Volume relevé du PR'
                      ? key
                      : 0
                  ],
              }}
            >
              {p[0][0] !== undefined && p[0][0].value !== null ? p[0][0].value : 'NR'}
            </span>
            <span
              style={{
                color:
                  colorization[key] === 'transparent' ? 'transparent' : 'black',
              }}
            >
              {' / '}
            </span>
            <span
              style={{
                color:
                  colorization[
                    pTitle !== 'Niveaux d\'eau du PR' &&
                    pTitle !== 'Volume relevé du PR'
                      ? key
                      : 1
                  ],
              }}
            >
              {p[1][0] !== undefined && p[1][0].value !== null ? p[1][0].value : 'NR'}
            </span>
          </div>
        );
      }): <div style={{color:'red'}}><p>&nbsp;Pas de seuil calculé !</p></div>) 
      }
    </div>
  );
};

export const adjustPositionOfPopup = (props) => {
  const { x, y } = props.center;
  // Dimensions du conteneur SVG
  const svgWidth = 700; // Remplacez par la largeur réelle de votre graphique
  const svgHeight = 570; // Remplacez par la hauteur réelle de votre graphique
  // Dimensions du tooltip
  const tooltipWidth = 280;
  const tooltipHeight = 100;
  // Ajuster la position du tooltip pour qu'il soit toujours visible
  const adjustedX = x + tooltipWidth > svgWidth ? x - tooltipWidth - 5 : x + 5;
  const adjustedY = y + tooltipHeight > svgHeight ? y - tooltipHeight - 5 : y + 5;
  return { adjustedX, adjustedY };
};

export const CustomTooltipForLevels = (props) => {
  const { time, value } = props.datum;
  return (
    <foreignObject width={230} height={100} x={adjustPositionOfPopup(props).adjustedX} y={adjustPositionOfPopup(props).adjustedY}>
      <div style={{ fontSize: '13px', backgroundColor: '#F8F8FF', padding: '5px', borderRadius: '5px', boxShadow: 'rgba(149, 157, 165, 0.2) 5px 8px 24px', border: '1px solid rgb(237, 242, 250)' }}>
        <p style={{ fontWeight: '600' }}>{`${time.toLocaleDateString()}`}</p>
        <p style={{ display: 'inline-flex' }}>{`Niveau moyen :`}&nbsp;<p style={{ color: '#A6611A', fontWeight: 'bold' }}>{`${parseFloat(props.data[1][props.index].value).toPrecision(2)} m`}</p></p>
        <p style={{ display: 'inline-flex' }}>{`Niveau min - max :`}&nbsp;<p style={{ color: '#009E73', fontWeight: 'bold' }}>{`${parseFloat(props.data[2][props.index].value).toPrecision(2)}`}</p>&nbsp;-&nbsp;<p style={{ color: '#0072B2', fontWeight: 'bold' }}>{`${parseFloat(props.data[0][props.index].value).toPrecision(2)} m`}</p></p>
        {/* <p>{`Niveau nappe : ${value} m`}</p> */}
      </div>
    </foreignObject>
  );
};

// formate data for specific mode
// tresholds is two list of two points in a list
export const getTresholdsFormated = (pMode: string, pTresholds: any[]) => {
  if (pMode === 'multiple') {
    let values: any[] = [];
    pTresholds.forEach((d) => {
      values.push(d);
    });
    return values;
  } else {
    return pTresholds;
  }
};

export const updateComponent = (pTitle: string, pData: any) => {
  if (pTitle === 'Niveaux d\'eau du PR') {
    let arraysAreEmpty = 0;
    pData.forEach((d) => {
      if(d.length === 0){
        arraysAreEmpty += 1;
      }
    });
    return arraysAreEmpty === pData.length ? false : true;
  } else {
    return pData.length === 0 ? false : true;
  }
};